import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// "proxy": "http://ayditest.fayatech.ir/",

import { Link } from "react-router-dom";

// styles
import styles from "./UserMyNotes.module.css";
import Dstyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "../../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../../UserSideDashboard/UserSideDashboard";
import MyNotesCard from "../../../Dashboard/Notes/MyNotes/MyNotesCard";
import Footer from "../../../Home/Footer/Footer";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CustomPagination from "../../../CustomPagination/CustomPagination";

export default function UserMyNotes() {
  const { userToken } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [notesData, setNotesData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const getApiData = await axios.get("Note", {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getApiData.data.data.pageCount };
      });
      setNotesData(getApiData.data.data.data);
      setIsLoading(false);
    };
    getData();
  }, [userToken]);

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard notes />
                <div className={`d-flex flex-column align-items-center justify-content-start p-md-4 p-3 ${styles.main_container}`}>
                  <div className="w-100 d-flex flex-md-row flex-column align-items-center justify-content-md-between justify-content-center flex-wrap mb-md-5 mb-3">
                    <div className={`my-md-0 my-3 ${styles.title}`}>یادداشت‌ها</div>
                    <Link to="/user-add-note" className={`my-md-0 my-3 ${styles.primary}`}>
                      <svg className="ms-2 ms-md-0" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7 0.75C7.34518 0.75 7.625 1.02982 7.625 1.375V6.375H12.625C12.9702 6.375 13.25 6.65482 13.25 7C13.25 7.34518 12.9702 7.625 12.625 7.625H7.625V12.625C7.625 12.9702 7.34518 13.25 7 13.25C6.65482 13.25 6.375 12.9702 6.375 12.625V7.625H1.375C1.02982 7.625 0.75 7.34518 0.75 7C0.75 6.65482 1.02982 6.375 1.375 6.375H6.375V1.375C6.375 1.02982 6.65482 0.75 7 0.75Z"
                          fill="#21409A"
                        />
                      </svg>
                      افزودن یادداشت
                    </Link>
                  </div>

                  <div className="w-100 mb-5">
                    <MyNotesCard notesData={notesData} user />
                  </div>

                  <Stack
                    className={Dstyles.pagination}
                    spacing={1}
                    sx={{
                      direction: "ltr",
                      bottom: "0",
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center !important",
                    }}>
                    {/* <Typography>Page: {page}</Typography> */}
                    <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                  </Stack>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getApiData = await axios.get(`Note?PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    setPage(prev => {
      return { ...prev, pageCount: getApiData.data.data.pageCount, pageNumber: value };
    });
    setNotesData(getApiData.data.data.data);
    setIsLoading(false);
  }
}
